import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { EditTaskDialog } from './editTaskDialog';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@roc/feature-app-core';
import { DialogState } from '@roc/ui';
import { makeStyles } from '@material-ui/core';
import { GeneralTaskType } from '../../types/generalTasksTypes';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: 'transparent !important',
    },
  },
}));

const decodeData = (encodedData: string) => {
  if (!encodedData) {
    return null;
  }
  try {
    return atob(decodeURIComponent(encodedData));
  } catch (e) {
    return encodedData;
  }
}

export const CreateTaskDialogInternal = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const { loanId } = useParams<{ loanId: string }>();
  const query = useQuery();
  const [dialogState, setDialogState] = useState<DialogState | null>(null);
  useStyles();

  useEffect(() => {
    if (query.get('openModal') === 'true' && dialogState === null) {
      const assigneeId = query.get('assigneeId');
      const title = decodeData(query.get('title'));
      const priority = decodeData(query.get('priority'));
      const taskType = decodeData(query.get('taskType'));
      generalTasksStore.setLoanId(Number(loanId));
      editTaskStore.openAddTask(loanId, null, {
        assigneeId: assigneeId ? Number(assigneeId) : null,
        title,
        priority,
        taskType: taskType as GeneralTaskType,
      });
      generalTasksStore.fetchUserInfoAndAssigneeOptions(loanId);
      setDialogState(DialogState.ADD);
      window.parent.postMessage({ action: 'modal-ready' }, '*');
    }
  }, [query, loanId, dialogState]);

  useEffect(() => {
    if (dialogState === DialogState.ADD && editTaskStore.dialogState === null) {
      window.parent.postMessage({ action: 'close-modal' }, '*');
      setDialogState(null);
    }
  }, [editTaskStore.dialogState]);

  return <EditTaskDialog />;
});
